import PropTypes from 'prop-types';
import clsx from 'clsx';
import Image from '@/components/Image';

const defaultProps = {
  testimonial: null,
};

const propTypes = {
  modalDescription: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired,
  testimonial: PropTypes.shape({
    title: PropTypes.string,
    info: PropTypes.shape({
      company: PropTypes.string.isRequired,
      position: PropTypes.string.isRequired,
      testimonial: PropTypes.string.isRequired,
    }).isRequired,
    featuredImage: PropTypes.shape({
      node: PropTypes.shape({
        sizes: PropTypes.string,
        sourceUrl: PropTypes.string,
        srcSet: PropTypes.string,
      }),
    }),
  }),
};

export default function DownloadProgramTestimonial({
  modalDescription,
  modalTitle,
  testimonial,
}) {
  return (
    <div className="w-full flex flex-col p-6 lg:p-8 xl:p-10 space-y-10">
      <div
        className={clsx(
          'space-y-3 flex-1',
          testimonial && 'lg:space-y-4',
          !testimonial && 'lg:space-y-6 flex flex-col justify-center lg:px-10',
        )}
      >
        <h3
          className={clsx(
            'text-2xl lg:text-3xl font-semibold lg:font-bold tracking-tight ',
            testimonial && 'leading-8',
            !testimonial && 'leading-10',
          )}
        >
          {modalTitle}
        </h3>
        <p className="text-gray-500 text-base">
          {modalDescription}
        </p>
      </div>
      {testimonial && (
        <div className="space-y-6">
          <div className="font-semibold">
            <svg width="45" height="36" className="mb-5 fill-current text-green-200">
              <path d="M13.415.001C6.07 5.185.887 13.681.887 23.041c0 7.632 4.608 12.096 9.936 12.096 5.04 0 8.784-4.032 8.784-8.784 0-4.752-3.312-8.208-7.632-8.208-.864 0-2.016.144-2.304.288.72-4.896 5.328-10.656 9.936-13.536L13.415.001zm24.768 0c-7.2 5.184-12.384 13.68-12.384 23.04 0 7.632 4.608 12.096 9.936 12.096 4.896 0 8.784-4.032 8.784-8.784 0-4.752-3.456-8.208-7.776-8.208-.864 0-1.872.144-2.16.288.72-4.896 5.184-10.656 9.792-13.536L38.183.001z" />
            </svg>
            <blockquote dangerouslySetInnerHTML={{ __html: testimonial.info.testimonial }} />
          </div>
          <div className="space-x-4 font-medium text-gray-500 flex items-center w-full">
            <Image
              src={testimonial.featuredImage.node.sourceUrl}
              alt={testimonial.title}
              className="w-10 h-10 rounded-full bg-gray-100"
              width={120}
              height={120}
            />
            <h5 className="text-sm leading-5 font-medium text-gray-900">
              {testimonial.title}
              <br />
              <div className="font-normal text-gray-500 text-xs">
                {`${testimonial.info.position} en ${testimonial.info.company}`}
              </div>
            </h5>
          </div>
        </div>
      )}
    </div>
  );
}

DownloadProgramTestimonial.defaultProps = defaultProps;
DownloadProgramTestimonial.propTypes = propTypes;
